import { AfterViewInit, Component, Input, Output, ElementRef, EventEmitter, OnInit, Renderer, ViewChild } from '@angular/core';

import { GooglemapsRoutingModule } from './googlemaps.routing.module';

declare const $: any;
declare const google: any;

@Component({
  selector: 'googlemaps',
  template: `<div id="map-container" class="z-depth-1" style="height: 300px" #maps></div>`,
})

export class GooglemapsComponent implements AfterViewInit {
  @Input() public name: string = '';
  @Input() public caption: string = '';
  @Input() public enabled: Boolean = false;
  @ViewChild('maps') maps: ElementRef;
  constructor() {
  }

  ngAfterViewInit(): void {
    this.loadScript('assets/js/googlemaps.min.js?key=AIzaSyDh3DwWuZ6sq_5iiscTe75M08dm74PzGDA&callback=initMap');
    //google.maps.event.addDomListener(window, 'load', this.init_map);
  }

  init_map() {
    let var_location = new google.maps.LatLng(40.725118, -73.997699);

    let var_mapoptions = {
      center: var_location,

      zoom: 14
    };

    let var_map = new google.maps.Map(document.getElementById('map-container'),
      var_mapoptions);

    let var_marker = new google.maps.Marker({
      position: var_location,
      map: var_map,
      title: 'New York'
    });

    var_marker.setMap(var_map);
  }

  loadScript(name: string) {
    let s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = name;
    s.async = true;
    s.defer = true;
  }
}
